import { commands } from './index';

export class TokenStream {
  private position: number;
  private tokens: { type: string; value: string; commands?: string[][]; isPartial?: boolean }[];
  private input: string;
  private keywords!: string[][];

  constructor(input: string) {
    this.position = 0;
    this.tokens = [];
    this.input = input?.toLowerCase();
    this.buildKeywords();
  }

  buildKeywords() {
    this.keywords = commands.map((keyword) => keyword.toLowerCase().split(' '));
  }

  tokenize() {
    while (this.position < this.input.length) {
      const word = this.getNextWord();
      let { options: parts, hasPartials } = this.getKeywordParts(word);
      switch (true) {
        case word === '':
          break;
        case parts.length == 1:
          this.tokens.push({
            type: 'command',
            value: word,
            commands: [parts[0]],
            isPartial: word !== parts[0].join(' '),
          });
          break;
        case parts.length > 1:
          if (!this.isEnd()) {
            parts = parts.filter((part) => part.some((p) => p === word));
          }
          this.tokens.push({
            type: 'command-part',
            value: word,
            commands: parts,
            isPartial: hasPartials,
          });
          break;
        default:
          this.tokens.push({ type: 'parameter', value: word });
      }
    }
    return this.tokens;
  }

  getNextWord() {
    let word = '';
    this.skipWhitespace();
    let escapedToken = false;
    while (
      this.position < this.input.length &&
      (!this.isWhitespace(this.input[this.position]) || (escapedToken && this.isWhitespace(this.input[this.position])))
    ) {
      if (this.input[this.position] === '"') {
        escapedToken = !escapedToken;
        this.position++;
        continue;
      }
      word += this.input[this.position];
      this.position++;
    }
    return word;
  }

  getKeywordParts(word: string) {
    const options: string[][] = [];
    let hasPartials = false;
    for (let i = 0; i < this.keywords.length; i++) {
      if (this.keywords[i].some((part) => part === word)) {
        options.push(this.keywords[i]);
      } else if (this.keywords[i].some((part) => part.startsWith(word))) {
        options.push(this.keywords[i]);
        hasPartials = true;
      }
    }
    return { options, hasPartials };
  }

  isWhitespace(char: string) {
    return /\s/.test(char);
  }

  skipWhitespace() {
    while (this.position < this.input.length && this.isWhitespace(this.input[this.position])) {
      this.position++;
    }
  }

  isEnd() {
    return this.position >= this.input.length;
  }
}
